exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.medicalResponsibility .cont p {\n  margin-bottom: 0.4rem;\n}", ""]);

// exports
